import { getStats } from '@/data/loader';
import { useTranslation } from '@/hooks/useTranslation';
import { Container } from '@/components/Container';

export function CredibilitySection() {
  const { t } = useTranslation();
  const stats = getStats();

  const items = [
    {
      id: 'cataloged',
      num: String(stats.total),
      label: t('home.credibility.catalogedPoints'),
      icon: '📍',
    },
    { id: 'updated', num: '2026', label: t('home.credibility.updatedThisYear'), icon: '📅' },
    { id: 'nocars', num: '0', label: t('home.credibility.noCars'), icon: '🚶' },
  ];

  return (
    <section className="py-10 sm:py-12">
      <Container>
        <div className="grid grid-cols-3 md:grid-cols-3 gap-4 md:gap-6 max-w-3xl mx-auto">
          {items.map(s => (
            <div key={s.id} className="text-center p-4">
              <span className="text-2xl mb-1 block">{s.icon}</span>
              <div className="font-display text-3xl text-teal-deep">{s.num}</div>
              <div className="font-body text-sm text-warm-gray mt-0.5">{s.label}</div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
